"use client";

import React, { useEffect, useState } from "react";
import { Card, Form } from "react-bootstrap";
import { fetchTrendStats } from "../../../../api/api";

const SalesReport = () => {
  const [Chart, setChart] = useState(null);
  const [range, setRange] = useState("week");
  const [chartData, setChartData] = useState([]);

  const user =
    typeof window !== "undefined"
      ? JSON.parse(localStorage.getItem("user"))
      : null;

  // load chart lib
  useEffect(() => {
    import("react-apexcharts").then((mod) => {
      setChart(() => mod.default);
    });
  }, []);

  // fetch backend data
  useEffect(() => {
    if (!user?.id) return;

    fetchTrendStats(user.id, range)
      .then((res) => {
        setChartData(res || []);
      })
      .catch((err) => {
        console.error("Trend fetch error:", err);
        setChartData([]);
      });
  }, [user, range]);

  // transform backend data
  const categories = chartData.map((d) => d.label);

  const values = chartData.map((d) =>
    d.total ? Number((d.total / 3600).toFixed(1)) : 0
  );

  const series = [
    {
      name: "Worked Hours",
      data: values,
    },
  ];

  const options = {
    chart: {
      zoom: { enabled: false },
      toolbar: { show: true },
    },
    dataLabels: { enabled: false },
    colors: ["#605DFF"],
    stroke: {
      curve: "straight",
      width: 2,
    },
    grid: {
      show: true,
      borderColor: "#F6F7F9",
    },
    markers: {
      size: 4,
      strokeWidth: 0,
      shape: "diamond",
      hover: { size: 5 },
    },
    xaxis: {
      categories: categories,
      axisTicks: { show: false },
      axisBorder: { show: false },
      labels: {
        show: true,
        style: {
          colors: "#8695AA",
          fontSize: "12px",
        },
      },
    },
    yaxis: {
      tickAmount: 6,
      min: 0,
      labels: {
        formatter: (val) => `${val}h`,
        style: {
          colors: "#64748B",
          fontSize: "12px",
        },
      },
    },
    legend: {
      show: true,
      position: "top",
      horizontalAlign: "left",
      fontSize: "12px",
      labels: { colors: "#64748B" },
    },
  };

  return (
    <Card className="bg-white border-0 rounded-3 mb-4">
      <Card.Body className="p-4">
        <div className="d-flex justify-content-between align-items-center flex-wrap gap-3 mb-3">
          <h3 className="mb-0">Team Performance Trend</h3>

          {/* ✅ FILTER WORKING */}
          <Form.Select
            value={range}
            onChange={(e) => setRange(e.target.value)}
            className="form-control p-0 h-auto border-0"
          >
            <option value="today">Today (Hourly)</option>
            <option value="week">Last 7 Days</option>
            <option value="month">Last 30 Days</option>
            <option value="year">Last 12 Months</option>
          </Form.Select>
        </div>

        <div style={{ marginLeft: "-10px", marginBottom: "-15px" }}>
          {Chart && (
            <Chart
              options={options}
              series={series}
              type="line"
              height={374}
            />
          )}
        </div>
      </Card.Body>
    </Card>
  );
};

export default SalesReport;